// extracted by mini-css-extract-plugin
export var activeFilterButton = "_q2-c";
export var backButton = "_q2-4";
export var backIcon = "_q2-5";
export var chevronShortcut = "_q2-6";
export var container = "_q2-1";
export var editor = "_q2-8";
export var editorWrapper = "_q2-7";
export var prefix = "_q2-2";
export var searchIcon = "_q2-3";
export var suffix = "_q2-9";
export var suffixContent = "_q2-a";
export var suffixText = "_q2-b";
export var wrapper = "_q2-0";